import { render, staticRenderFns } from "./BillingSummaryCard.vue?vue&type=template&id=894c817e&scoped=true"
import script from "./BillingSummaryCard.vue?vue&type=script&lang=js"
export * from "./BillingSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894c817e",
  null
  
)

export default component.exports